export function loadModel<T>(context: string, key: string, defaultValue: T): T {
  try {
    const saved = localStorage.getItem(`${context}${key}`)
    if (!saved) return defaultValue
    // Try to parse as JSON first
    try {
      return JSON.parse(saved)
    } catch {
      // If parsing fails, the value might be a raw string - return it as-is if T is string type
      return saved as unknown as T
    }
  } catch (err) {
    console.error(`Error loading ${key} from localStorage:`, err)
    return defaultValue
  }
}
export function saveModel<T>(context: string, key: string, model: T): void {
  try {
    localStorage.setItem(`${context}${key}`, JSON.stringify(model))
  } catch (err) {
    console.error(`Error saving ${key} to localStorage:`, err)
  }
}
